let swiperA = new Swiper('.msdw-slider-fade', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoHeight: true
});

let swiperB = new Swiper('.msdw-slider-freemode', {
  slideToClickedSlide: true,
  freeMode: true,
  centeredSlides: false,
  slidesPerView: 'auto',
  breakpoints: {
    320: {
      centeredSlides: true,
      slidesPerView: 2,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: swiperA
  }
});



// SCROLL SPY

// function scrollSpy() {
//   var sections = document.querySelectorAll('.msdw-tab-section');
//   var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

//   for (var i in sections) {
//     if (sections.hasOwnProperty( i ) && sections[ i ].offsetTop-60 <= scrollPosition) {
//       var id = sections[ i ].id;

//       document.querySelector('.section-buttons .active').classList.remove( 'active' );
//       document.querySelector('a[href*=' + id + ']').classList.add( 'active' );

//     }
//     else if ($(window).scrollTop() + $(window).height() == $(document).height()) {
//       document.querySelector('.section-buttons .active').classList.remove( 'active' );
//       document.querySelector('[href="#anchor-faq"]').classList.add( 'active' );
//     }
//   }
// }

// $(window).on("load scroll",function(e){
//   scrollSpy();
// });




//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =SCROLL SPY
// --------------------------------------------------

// const sections = document.querySelectorAll('section[data-scroll-spy]');

// const cb = (entries) => {
//   entries.forEach((entry) => {
//     const id = entry.target.getAttribute('id');
//     entry.isIntersecting ?
//       document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.add('msdw-active') :
//       document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.remove('msdw-active');
//   });
// };

// const observer = new IntersectionObserver(cb, {
//   rootMargin: '0px 0px 40% 0px',
//   threshold: [0.75, 0.85]
// });

// sections.forEach((el) => observer.observe(el));
